export class MoleculePanelOverviewHeaderMultiDeleteRestorableDatabaseActionComponent {
    public templateUrl = require('./multi-delete-restorable-database-action.html?external');
}
